<template>
<div class="use-plan">
  <el-dialog :title="'编辑计划 （'+houseListCount+' 户）'" :close-on-click-modal="false" :visible.sync="visible" width="800px" @closed="close">
    <el-tabs v-model="tabsIndex">
      <el-tab-pane label="计划详情" name="0">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="催缴类型">
            <el-select size="mini" placeholder="催缴类型" disabled v-model="fromData.urge_type">
              <el-option :value="1" label="自催"></el-option>
              <el-option :value="2" label="项目诉讼"></el-option>
              <el-option :value="5" label="项目自催"></el-option>
              <el-option :value="3" label="第三方管理"></el-option>
              <el-option :value="4" label="第三方诉讼"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="催缴月份">
            <el-date-picker v-model="fromData.yearmonth"
                            size="mini"
                            type="month"
                            format="yyyy-MM"
                            value-format="yyyy-MM" placeholder="计划月份"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="合作单位" v-if="[3,4].includes(fromData.urge_type)">
            <el-select size="mini" placeholder="请选择合作单位" clearable filterable v-model="fromData.company_id">
              <el-option v-for="item in company_list" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <el-button size="mini" @click="close">取消</el-button>
      <el-button size="mini" type="primary" v-if="[5].includes(fromData.urge_type)" @click="submit">确定</el-button>
      <el-button size="mini" type="primary" v-if="[1,2,3,4].includes(fromData.urge_type)" @click="startProcess">发起流程</el-button>
    </template>
  </el-dialog>
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "UsePlanDialog",
  data(){
    return{
      visible:false,
      tabsIndex:0,
      fromData:{
        project_id:"", // 项目id
        urge_type:"", // 催缴类型
        yearmonth:"", // 年月
        company_id:"" // 公司id
      },
      company_list:[],
      house_list:[],
      _callback: null,
      type_id : 1,
    }
  },
  methods:{
    show({type_id,project_id,house_list,urge_type,yearmonth}, callback){
      this.visible = true;
      this.type_id=type_id;
      this.house_list = house_list;
      this.fromData.project_id = project_id;
      this.fromData.urge_type = urge_type;
      this.fromData.yearmonth = yearmonth;
      this._callback= callback;
      this.getCompanyList();
    },
    close(){
      this._callback=undefined;
      this.visible = false;
      this.house_list = [];
      this.company_list = [];
      this.fromData = {
        project_id:"", // 项目id
        urge_type:"", // 催缴类型
        yearmonth:"", // 年月
        company_id:"" // 公司id
      };
    },
    getCompanyList(){
      const that=this;
      that.company_list = [];
      ButlerHttp.get("ProjectCollectionThridCompany/getAllOfIdAndName",{}, res => {
        if (res.code) {
          that.company_list=res.data
        }
      });
    },
    submit(){
      const that=this;
      if(!that.fromData.yearmonth){
        that.$message.error("请选择计划月份");
        return;
      }
      ButlerHttp.post("HouseUrge/setUrgeType",{
        project_id:that.fromData.project_id,
        urge_type:that.fromData.urge_type,
        yearmonth:that.fromData.yearmonth,
        ch_md5s:that.chMd5s.join(',')
      }, res => {
        if (res.code) {
          typeof that._callback === "function" && that._callback();
          that.close();
        }
      });
    },
    startProcess(){
      const that=this;
      that.company_list = [];
      if(!that.fromData.yearmonth){
        that.$message.error("请选择计划月份");
        return;
      }
      if([3,4].includes(that.fromData.urge_type)&&!that.fromData.company_id){
        that.$message.error("请选择合作单位");
        return;
      }
      ButlerHttp.post("HouseUrge/setUrgeTypeFlow",{
        project_id:that.fromData.project_id,
        urge_type:that.fromData.urge_type,
        yearmonth:that.fromData.yearmonth,
        ch_md5s:that.chMd5s.join(','),
        company_id:that.fromData.company_id
      }, res => {
        if (res.code) {
          typeof that._callback === "function" && that._callback();
          let timeStr=(new Date()).getTime()
          let urge_type_obj={
            1:'来源于【自催】的调整',
            2:'来源于【诉讼】的调整',
            5:'来源于【项目自催】的调整',
            3:'来源于【第三方管理】的调整',
            4:'来源于【第三方诉讼】的调整'
          }
          let urge_type=urge_type_obj[that.fromData.urge_type]||"来源于【未知】的调整"
          if([3].includes(that.fromData.urge_type)&&that.fromData.company_id===135){
            // 李琦团队
            ERP.navigateTo(`/flow/FlowView?sheet_id=348&master_id=285&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
          }else if([3].includes(that.fromData.urge_type)&&that.fromData.company_id!==135){
            // 第三方管理
            if([4,5].includes(this.type_id)){
              // 撤场项目
              ERP.navigateTo(`/flow/FlowView?sheet_id=355&master_id=292&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
            }else {
              // 在管项目
              ERP.navigateTo(`/flow/FlowView?sheet_id=355&master_id=292&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
            }

          }else if([4].includes(that.fromData.urge_type)&&that.fromData.company_id!==135){
            // 第三方诉讼
            if([4,5].includes(this.type_id)){
              // 撤场项目
              ERP.navigateTo(`/flow/FlowView?sheet_id=359&master_id=296&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
            }else {
              // 在管项目
              ERP.navigateTo(`/flow/FlowView?sheet_id=359&master_id=296&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
            }

          }else {
            // 诉讼
            if([4,5].includes(this.type_id)){
              // 撤场项目
              ERP.navigateTo(`/flow/FlowView?sheet_id=357&master_id=294&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
            }else{
              // 在管项目
              ERP.navigateTo(`/flow/FlowView?sheet_id=360&master_id=180&timeValue=${timeStr}&batch_number=${res.data}&urge_type=${urge_type}`)
            }
          }

          that.close();
        }
      });
    },
  },
  computed:{
    houseListCount(){
      return this.house_list.length;
    },
    chMd5s(){
      return this.house_list.map(ret=>ret.ch_md5)
    }
  },
}
</script>

<style lang="scss" scoped>
.use-plan{
  >>> .el-dialog__body{
    padding: 10px 20px 30px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/UsePlanDialog.vue